import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProviderStatementEmailTemplate.Save.IRequest;
type Response = Api.Core.ProviderStatementEmailTemplate.Save.IResponse;
type Headers = Api.Core.ProviderStatementEmailTemplate.Save.IHeaders;
const url = '/api/Management/ProviderStatementEmailTemplate';
export default async function providerStatementEmailTemplateSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
